import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildQueryGreater, buildQueryLess, buildQueryRange, buildQueryTermEqual} from '../../query/elastic.queries';

export const dateExp = '(\\d|\\d{1,}-)+';
export const dateRegExp = new RegExp(`^${dateExp}$`);
export const dateRangeRegExp = new RegExp(`^(${dateExp})\\s*\.\\s*\.\\s*(${dateExp})$`);
export const dateGtRegExp = new RegExp(`^>\\s*(${dateExp})$`);
export const dateLtRegExp = new RegExp(`^<\\s*(${dateExp})$`);

export class DateParser implements ElasticParser {
  parseValue(datesString: string, elasticSearchProperty: ElasticSearchProperty): any {
    const {property} = elasticSearchProperty;

    const datesQueries = datesString?.split('|')
      .map(dateString => dateString.trim())
      .filter(dateString => !!dateString)
      .map(dateString => {
        const isDateStringADate = dateRegExp.test(dateString);
        const isDateStringARangeDate = dateRangeRegExp.test(dateString);
        const isDateStringGtDate = dateGtRegExp.test(dateString);
        const isDateStringLtDate = dateLtRegExp.test(dateString);

        if (isDateStringADate) {
          return buildQueryTermEqual(property, dateString);
        } else if (isDateStringARangeDate) {
          const match = dateRangeRegExp.exec(dateString);

          return buildQueryRange(property, match[1], match[3]);
        } else if (isDateStringGtDate) {
          const match = dateGtRegExp.exec(dateString);

          return buildQueryGreater(property, match[1]);
        } else if (isDateStringLtDate) {
          const match = dateLtRegExp.exec(dateString);

          return buildQueryLess(property, match[1]);
        } else {
          return undefined;
        }
      });

    const isDateQueriesDefined = datesQueries?.filter(query => !!query).length > 0;

    if (isDateQueriesDefined) {
      return {bool: {should: datesQueries}};
    } else {
      return undefined;
    }
  }
}

